<template>
	<div class="zp-content">
		<img-upload class="file-upload" :imageUrl="ruleForm.bridgeDocument" @downloadALink="downloadALink"
			ref="bridgeDocument" :isType="2" :limit="1" title="支持扩展名：doc .docx .pdf .xls .jpg <span style='color: #f55;'>且只能上传一个文件</span>"></img-upload>
		<div class="zp-contents">
			<div class="upload-div">
				<h3 style="text-align: left;">一桥一档图</h3>
				<img-uploadd class="upload-margin" :imageUrl="ruleForm.bridgePicture" ref="bridgePicture" :limit="1"
					:isType="1">
				</img-uploadd>
			</div>
		</div>
	</div>
</template>
<script>
	import imgUpload from '@/views/components/upLoad/imgUpload.vue';
	import imgUploadd from '@/views/components/upLoad/imgUploadd.vue';
	export default {
		name: 'yiqiaoyidang',
		props: [],
		components: {
			imgUpload,
			imgUploadd
		},
		data() {
			return {
				ruleForm: {
					bridgeDocument: [],
					bridgePicture: [],
				}
			};
		},
		mounted() {
		},
		watch: {
		},
		methods: {
			// 下载
			downloadALink(file) {
				console.log(file);
				const a = document.createElement('a');
				a.href = file.url;
				// a.download = '文件名1'; // 下载后文件名
				a.setAttribute("download", file.name);
				a.style.display = 'none';
				document.body.appendChild(a);
				a.click(); // 点击下载
				document.body.removeChild(a); // 下载完成移除元素
			},
			// 一桥一档提交
			async yiQiaoYiDangBC() {
				let data = {
					createByName: this.$store.state.user.accountName,
					createByUuid: this.$store.state.user.accountUuid,
					bridgeUuid: global.bridgeUuid
				};
				data.bridgeDocument = this.$refs.bridgeDocument.getString();
				data.bridgePicture = this.$refs.bridgePicture.getString();
				console.log(data);
				const res = await this.$api.sendPost('/biBridge/update', data);
				console.log(res);
				if (res.errcode == 0) {
					this.$message.success(res.errmsg);
					// 最后一步关闭弹框
					this.$emit('addVisible');
				} else {
					this.$message.error(res.errmsg);
				}
			},
		}
	};
</script>

<style lang="scss">
	.zp-content {
		margin-left: 40px;
		height: 700px;
		overflow: auto;
		position: relative;
	}

	.file-upload {
		width: 500px;
	}

	.zp-contents {
		width: 100%;
		position: absolute;
		left: 0px;
		bottom: 0px;
		overflow: auto;


		h3 {
			font-size: 18px;
			color: #333333;
			margin-bottom: 20px;
		}

		.upload-div {
			margin-bottom: 40px;

			.model-upload {
				display: flex;

				.upload-margin {
					margin-right: 40px;
				}
			}
		}

		.flex-upload {
			display: flex;

			.flex-upload-margin {
				margin-right: 20px;
			}
		}

		.el-upload-list--picture-card {
			float: left;

			li {
				float: left;
			}
		}
	}
</style>
